import { Component, Input, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { tooltipTriggers } from 'src/app/common/function';
import { RestaurantDetails } from 'src/app/models/restaurant-details';
import { BusinessService } from 'src/app/services/business.service';

@Component({
  selector: 'app-restaurant-detail-modal',
  templateUrl: './restaurant-detail-modal.component.html',
  styleUrls: ['./restaurant-detail-modal.component.scss']
})
export class RestaurantDetailModalComponent {

  @Input() restaurantDetails: RestaurantDetails;
  @ViewChild('restaurantDetailModal')
  restaurantDetailModalTemplate!: TemplateRef<RestaurantDetailModalComponent>;
  visibleChipCount = 2;
  hoursTooltipTriggers = tooltipTriggers();

  constructor(
    private router: Router,
    private businessService: BusinessService
  ) { }
  openBusinessDetails() {
    this.businessService.markListingReturnPending();
    this.router.navigate(['business-detail', this.restaurantDetails.id]);
  }

  getDayName(day: number): string {
    const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return dayNames[day];
  }

  /** Idempotent: mouseover (desktop) and click (touch/keyboard) both land here. */
  showMoreTags(item, event?: Event) {
    event?.stopPropagation();
    item.showMore = true;
  }
}
